// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"0388d57e","220":"3a187cff","475":"93528213","641":"addb2f91","830":"a0f1ac04","981":"6aca5d70"}[chunkId] + ".chunk.css";
};